"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import TagsRelatedMovies from "@/components/pages/tags/TagsRelatedMovies";
import { GenreContent, GenreContentItem, GenreMeta } from "@/types/tag";
import { getContentByGenre } from "@/services/tag";
interface Props {
  slug: string;
  serverData: GenreContent;
  mode?: "tag" | "block";
}
export default function TagsContent(t0) {
  const $ = _c(11);
  const {
    serverData,
    slug,
    mode: t1
  } = t0;
  const mode = t1 === undefined ? "tag" : t1;
  let t2;
  if ($[0] !== serverData.content || $[1] !== serverData.items) {
    t2 = serverData.items || serverData.content || [];
    $[0] = serverData.content;
    $[1] = serverData.items;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const initialItems = t2;
  const initialMeta = serverData.meta;
  let t3;
  if ($[3] !== initialMeta?.limit || $[4] !== slug) {
    t3 = async page => {
      const res = await getContentByGenre({
        genre: slug,
        page,
        limit: initialMeta?.limit ?? 20
      });
      if (res.succeed === false) {
        throw new Error("load_more_failed");
      }
      const data = (res as {
        data: GenreContent;
        succeed: true;
      }).data;
      return {
        items: data.items || data.content || [],
        meta: data.meta
      };
    };
    $[3] = initialMeta?.limit;
    $[4] = slug;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  initialMeta?.limit;
  const handleLoadMore = t3;
  const t4 = mode === "tag" ? handleLoadMore : undefined;
  let t5;
  if ($[6] !== initialItems || $[7] !== initialMeta || $[8] !== slug || $[9] !== t4) {
    t5 = <div className="mx-auto container max-w-3xl pt-25 pb-12 px-6 md:px-10"><TagsRelatedMovies title={slug} movies={initialItems} meta={initialMeta} onLoadMore={t4} /></div>;
    $[6] = initialItems;
    $[7] = initialMeta;
    $[8] = slug;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}